import React, { ReactNode } from 'react'
import DocumentSidebarLayout from 'containers/DocumentSidebarLayout'
import EmptyHeader from 'containers/EmptyHeader'
import styled from 'styled-components'
import Footer from 'components/Footer'
import {
  Flex,
  LoadingPlaceholder,
  NotEmbedded,
  IsEmbedded,
} from '@sketch/components'

/**
 * TODO: reuse code between Layout and LoadingPage
 * https://github.com/sketch-hq/Cloud/issues/3543
 */
const Container = styled.div`
  width: 100%;
  height: 100%;
  background-color: ${({ theme }) => theme.colors.background.secondary.B};
  display: flex;
  flex-direction: column;
  flex: 1 0 auto;
`

export type SidebarLoadingPageProps = {
  logo?: ReactNode
  footer?: ReactNode
  sidebarRight?: ReactNode
}

export const SidebarLoadingPage = ({
  footer = <Footer />,
  sidebarRight = () => null,
}: SidebarLoadingPageProps) => (
  <Container>
    <DocumentSidebarLayout
      header={
        <>
          <NotEmbedded>
            <EmptyHeader hideLogo />
          </NotEmbedded>
          <IsEmbedded>
            <EmptyHeader />
          </IsEmbedded>
        </>
      }
      footer={footer}
      sidebarRight={sidebarRight}
    >
      <Flex
        flexDirection="column"
        height="100vh"
        alignItems="center"
        justifyContent="center"
      >
        <LoadingPlaceholder size="64px" />
      </Flex>
    </DocumentSidebarLayout>
  </Container>
)
